module.exports = __webpack_public_path__ + "img/AS.5d8efaba.svg";